<template>
  <v-row justify="center">
    <v-dialog
      persistent
      v-model="showDialogComp"
      scrollable
      max-width="800"
      @click:outside="cancel"
    >
      <v-card>
        <v-card-title>Select Media</v-card-title>
        <v-divider></v-divider>

        <v-card-text max-height="600">
          <v-list three-line flat>
            <v-list-item-group v-model="settings" multiple>
              <v-list-item v-for="m in mediaComp" :key="m.id" @click="check(m)">
                <template v-slot:default="{ active, toggle }">
                  <v-list-item-action>
                    <v-checkbox v-model="active" color="primary"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-content>
                    <menu-item-media-card
                      :gridView="gridView"
                      :media="m"
                    ></menu-item-media-card>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-on:click="cancel">cancel</v-btn>
          <v-btn v-on:click="done">done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import MenuItemMediaCard from '../components/MenuItemMediaCard'

export default {
  components: {
    MenuItemMediaCard
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    menuItemId: {
      type: String,
      required: true
    }
  },
  computed: {
    mediaComp: {
      get: function() {
        return this.media
      },
      set: function(newValue) {
        this.media = newValue
      }
    },
    showDialogComp: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        this.show = newValue
      }
    }
  },
  created: function() {
    this.showDialogComp = this.showDialog
    this.mediaComp = this.$store.state.MediaStore.media
  },
  methods: {
    cancel: function() {
      this.$emit('cancel')
    },
    done: function() {
      this.$store
        .dispatch('MenuItemsStore/linkMenuItemWithMedia', {
          menuItemId: this.menuItemId,
          mediaIds: this.mediaIds
        })
        .then(() => {
          this.$store.dispatch('MediaStore/setContext', 'menu_item')
          this.$store.dispatch(
            'MenuItemsStore/selectMenuItem',
            this.$route.params.menuItemId,
            { root: true }
          )
        })
        .then(() => {
          this.mediaComp = this.$store.state.MediaStore.media
        })
        .then(() => {
          this.$emit('done')
        })
    },
    check: function(media) {
      if (this.mediaIds.indexOf(media.id) === -1) {
        this.mediaIds.push(media.id)
      } else {
        this.mediaIds.splice(this.mediaIds.indexOf(media.id), 1)
      }
    }
  },
  data() {
    return {
      settings: [],
      mediaIds: [],
      show: false,
      gridView: false
    }
  }
}
</script>
